import { GetStagesItem } from "@microtica/ms-engine-sdk";
import { Button, Col, Row, Space } from "antd";
import { useEffect, useState } from "react"
import { getEnvironmentService } from "../../backend";
import GridList from "../../components/GridList";
import moment from "moment-timezone";
import { CalendarOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import Templates from "../template/Templates";
import CreateEnvironment from "../../components/CreateEnvironment";
import CreateEnvironmentModal from "./CreateEnvironmentModal";
import { fetchProjectLimitations } from "../../utils/local-storage";
import LimitationReachedMessage from "../../components/LimitationReachedMessage";
import ExplanationButton from "../../components/explanations/ExplanationButton";
import EnvironmentExplanation from "../../components/explanations/EnvironmentExplanation";

const ProjectEnvironments = () => {
    const { projectId } = useParams();
    const [environments, setEnvironments] = useState<GetStagesItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [createEnvironmentModalVisible, setCreateEnvironmentModalVisible] = useState(false);
    const [disableCreateEnvironment, setDisableCreateEnvironment] = useState(false);
    const { environmentsAllowed } = fetchProjectLimitations();

    useEffect(() => {
        const interval = setInterval(async () => {
            await loadData();
        }, 5000);
        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        if (projectId) {
            loadData();
        }
    }, [projectId]);

    const loadData = async () => {
        try {
            const { data: { stages: environments } } = await getEnvironmentService().getStages(projectId!);
            setEnvironments(environments);
        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        // Limitations message logic
        if (environmentsAllowed <= environments.length) {
            setDisableCreateEnvironment(true);
        }
    }, [environments])

    return (
        <>
            <Space direction="vertical" size="large" className="full-width">
                {!!environments.length &&
                    <Row gutter={24}>
                        <Col xs={24} sm={12} md={6}>
                            <h3>
                                Environments
                                <ExplanationButton
                                    content={<EnvironmentExplanation />}
                                />
                            </h3>
                        </Col>
                        <Col xs={24} sm={12} md={18} style={{ textAlign: "right" }}>
                            <LimitationReachedMessage
                                visible={disableCreateEnvironment}
                                text={`${environments.length}${environments.length === 1 ? " environment" : " environments"}`}
                            />
                            <Button
                                disabled={disableCreateEnvironment}
                                onClick={() => {
                                    setCreateEnvironmentModalVisible(true);
                                }}>
                                <PlusCircleOutlined />
                                Create environment
                            </Button>
                        </Col>
                    </Row>
                }
                <GridList
                    itemsInRow={3}
                    loading={loading}
                    disableEmptyState={true}
                    dataSource={environments.map(env => ({
                        key: env.id,
                        title: env.name,
                        description: env.description,
                        tags: [
                            {
                                position: "bottom",
                                value:
                                    <Space>
                                        <CalendarOutlined />
                                        {`Last updated ${moment(env.lastDeployed).fromNow()}`}
                                    </Space>
                            },

                        ],
                        link: `/projects/${projectId}/environments/${env.id}`
                    }))}
                />
                {
                    !loading && environments.length === 0 &&
                    <>
                        <CreateEnvironment onSuccessfullyCreatedStage={loadData} />
                        <Templates disableImport={true} />
                    </>
                }
            </Space>

            {createEnvironmentModalVisible && <CreateEnvironmentModal
                visible={createEnvironmentModalVisible}
                onCancel={() => setCreateEnvironmentModalVisible(false)}
                onOk={async () => {
                    await loadData();
                    setCreateEnvironmentModalVisible(false);
                }}
            />}
        </>
    )
}

export default ProjectEnvironments;